import { Project } from "./../../project-policy-config/project";
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef
} from "@angular/core";

import { downloadFile, toPromise } from "../../utils";
import { SystemInfoService, HelmChartService } from "../../service/index";
import { HelmChartDetail, SystemInfo } from "./../../service/interface";
import { ErrorHandler } from "./../../error-handler/error-handler";

@Component({
  selector: "hbr-chart-detail",
  template: `<div>
    <div class="flex-container">
        <div class="title-container">
            <div class="chart-name">
                {{chartNameWithVersion | translate}}
            </div>
            <div>
                {{roleName | translate}}
            </div>
        </div>
        <div>
            <button class="btn btn-sm btn-secondary"
            (click)="downloadChart()">{{'HELM_CHART.DOWNLOAD' | translate}}</button>
        </div>
    </div>
    <span *ngIf="loading" class="spinner spinner-lg detail-loading">
        Loading...
    </span>
    <div *ngIf="!loading && isChartExist">
        <clr-tabs>
            <clr-tab>
                <button clrTabLink id="summary-link">{{'HELM_CHART.SUMMARY' | translate}}</button>
                <clr-tab-content id="summary-content" *clrIfActive>
                    <hbr-chart-detail-summary
                    [summary]="chartDetail.metadata"
                    [chartName]="chartName"
                    [repoURL]="repoURL"
                    [projectName]="project.name"
                    [chartVersion]="chartVersion"
                    [security]="chartDetail.security"
                    [readme]="chartDetail.files['README.md']"></hbr-chart-detail-summary>
                </clr-tab-content>
            </clr-tab>
            <clr-tab>
                <button clrTabLink id="depend-link">{{'HELM_CHART.DEPENDENCIES' | translate}}</button>
                <clr-tab-content id="depend-content">
                    <hbr-chart-detail-dependency [dependencies]='chartDetail.dependencies'></hbr-chart-detail-dependency>
                </clr-tab-content>
            </clr-tab>
            <clr-tab>
                <button clrTabLink id="value-link">{{'HELM_CHART.VALUES' | translate}}</button>
                <clr-tab-content id="value-content">
                    <hbr-chart-detail-value
                    [values]="chartDetail.values"
                    [yaml]="chartDetail.files['values.yaml']"></hbr-chart-detail-value>
                </clr-tab-content>
            </clr-tab>
        </clr-tabs>
    </div>
    <div *ngIf="!loading && !isChartExist">
        <h6>{{'HELM_CHART.NO_DETAIL' | translate }}</h6>
    </div>

</div>`,
  styles: [`.title-container{display:flex}.title-container .chart-name{border-right:1px solid gray;font-size:27px;font-weight:400;padding-right:9px;margin-right:9px}.detail-loading{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;width:108px!important;height:108px!important}.flex-container{display:flex;-webkit-display:flex;justify-content:space-between}.flex-container .title-container{display:flex;align-items:center}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartDetailComponent implements OnInit {
  @Input() projectId: number;
  @Input() project: Project;
  @Input() chartName: string;
  @Input() chartVersion: string;
  @Input() roleName: string;
  @Input() hasSignedIn: boolean;
  @Input() hasProjectAdminRole: boolean;

  loading = true;
  isMember = false;
  chartDetail: HelmChartDetail;
  systemInfo: SystemInfo;

  repoURL = "";

  constructor(
    private errorHandler: ErrorHandler,
    private systemInfoService: SystemInfoService,
    private helmChartService: HelmChartService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    toPromise<SystemInfo>(this.systemInfoService.getSystemInfo())
      .then(systemInfo => {
        let scheme = 'http://';
        this.systemInfo = systemInfo;
        if (this.systemInfo.has_ca_root) {
          scheme = 'https://';
        }
        this.repoURL = `${scheme}${this.systemInfo.registry_url}`;
      })
      .catch(error => this.errorHandler.error(error));
    this.refresh();
  }
  public get chartNameWithVersion() {
    return `${this.chartName}:${this.chartVersion}`;
  }

  public get isChartExist() {
    return this.chartDetail ? true : false;
  }

  refresh() {
    this.loading = true;
    this.helmChartService
      .getChartDetail(this.project.name, this.chartName, this.chartVersion)
      .finally(() => {
        this.loading = false;
        let hnd = setInterval(() => this.cdr.markForCheck(), 100);
        setTimeout(() => clearInterval(hnd), 2000);
      })
      .subscribe(
        chartDetail => {
          this.chartDetail = chartDetail;
        },
        err => {
          this.errorHandler.error(err);
        }
      );
  }

  downloadChart() {
    if (!this.chartDetail ||
      !this.chartDetail.metadata ||
      !this.chartDetail.metadata.urls ||
      this.chartDetail.metadata.urls.length < 1) {
      return;
    }
    let filename = this.chartDetail.metadata.urls[0];

    this.helmChartService.downloadChart(this.project.name, filename).subscribe(
      res => {
        downloadFile(res);
      },
      error => {
        this.errorHandler.error(error);
      },
    );
  }
}
